export default {
  singleUser: {},
  allUsers: [],
  createUser: {},
};
